import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import { Menu, MenuItem } from './components/menu'
import headerBackground from './assets/images/background-header.jpg'
import hostelBackground from './assets/images/background-test.jpg'
import branchCoffee from './assets/images/branch-coffee.jpg'
import branchCake from './assets/images/branch-cake.jpg'
import branchJuice from './assets/images/branch-juice.jpg'
import branchTea from './assets/images/branch-tea.jpg'
import featureCoffee from './assets/images/feature-coffee.jpg'
import featureCoffee2 from './assets/images/feature-coffee-2.jpg'
import featureCream from './assets/images/feature-cream.jpeg'
import featureCake from './assets/images/feature-cake.jpg'
import featureCake2 from './assets/images/feature-cake-2.jpg'
import featureMilk from './assets/images/feature-milk.jpg'
import featureBannerHostel from './assets/images/feature-banner-hostel.jpg'
import bedIcon from './assets/icons/bed.svg'
import chairIcon from './assets/icons/chair.svg'
import bathIcon from './assets/icons/bath.png'
import fbIcon from './assets/icons/fb.svg'
import { hostelRooms } from './assets/data.js'
import { DearRef } from './utils/firebase'

class App extends Component {
  constructor(props) {
		super(props)
    this.state = {
      isShowToggleMenu: '',
      coffeeMenu: [],
      cakeMenu: [],
      milkMenu: [],
      sdr: {},
      dorm: {}
    }
    this.coffeeRef = React.createRef();
    this.cakeRef = React.createRef();
    this.milkRef = React.createRef();
    this.hostelRef = React.createRef();
	}

  componentDidMount() {
    if(DearRef.doc('menu') && DearRef.doc('menu').collection('coffee').get()) {
      DearRef.doc('menu').collection('coffee').get().then(snapshot => {
        let coffeeMenu = snapshot.docs.map((doc) => {
          return doc.data();
        })
        this.setState({coffeeMenu: coffeeMenu})
      })
      DearRef.doc('menu').collection('cake').get().then(snapshot => {
        let cakeMenu = snapshot.docs.map((doc) => {
          return doc.data();
        })
        this.setState({cakeMenu: cakeMenu})
      })
      DearRef.doc('menu').collection('milk').get().then(snapshot => {
        let milkMenu = snapshot.docs.map((doc) => {
          return doc.data();
        })
        this.setState({milkMenu: milkMenu})
      })

      // coffeeMenu.forEach(item => {
      //   let addedObj = {
      //     'image-src': item.imageSrc,
      //     'name': item.title,
      //     'price': item.price,
      //     'description': item.description
      //   }
      //   DearRef.doc('menu').collection('coffee').add(addedObj)
      //   .then(() => {
      //     console.log('success');
      //   })
      //   .catch((err) => {
      //     console.log('fail: ', err);
      //   })
      // })
      // milkMenu.forEach(item => {
      //   let addedObj = {
      //     'image-src': item.imageSrc,
      //     'name': item.title,
      //     'price': item.price,
      //     'description': item.description
      //   }
      //   DearRef.doc('menu').collection('milk').add(addedObj)
      //   .then(() => {
      //     console.log('success');
      //   })
      //   .catch((err) => {
      //     console.log('fail: ', err);
      //   })
      // })
    }

    if(DearRef.doc('room') && DearRef.doc('room').collection('sdr').get()) {
      DearRef.doc('room').collection('sdr').get().then(snapshot => {
        this.setState({sdr: snapshot.docs[0] ? snapshot.docs[0].data() : {}})
      })
    }
    if(DearRef.doc('room') && DearRef.doc('room').collection('dorm').get()) {
      DearRef.doc('room').collection('dorm').get().then(snapshot => {
        this.setState({dorm: snapshot.docs[0] ? snapshot.docs[0].data() : {}})
      })
    }




    (function($) {
      window.$(document).ready(function(){
        $('.owl-carousel').owlCarousel({
          loop:true,
          margin:10,
          autoWidth:true,
          responsiveClass:true,
          responsive:{
            0:{
              items:1,
              nav:false
            },
            600:{
              items:2,
              nav:false
            },
            1000:{
              items:1,
              nav:false,
              loop:false
            }
          }
        })
      });
    }) (window.$);
  }

  executeScroll = (ref) => window.scrollTo(0, ref.current.offsetTop)

  toggleMenu = () => {
    let isShow = (this.state.isShowToggleMenu === '') ? 'show' : '';
    this.setState({isShowToggleMenu: isShow})
  }

  render() {
    let { coffeeMenu, cakeMenu, milkMenu, sdr, dorm } = this.state;
    return (
      <div className="App">
        <div id='header'>
          <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
            <div className="container">
              <a className="navbar-brand" href="index.html">Dear,</a>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="true" aria-label="Toggle navigation" onClick={this.toggleMenu}>
                <span className="oi oi-menu"></span> Menu
                </button>

                <div className={"collapse navbar-collapse " + this.state.isShowToggleMenu} id="ftco-nav">
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item active"><a href="index.html" className="nav-link">Home</a></li>
                    <li className="nav-item"><a href="about.html" className="nav-link">About</a></li>
                    <li className="nav-item"><a href="menu.html" className="nav-link">Menu</a></li>
                    <li className="nav-item"><a href="blog.html" className="nav-link">Stories</a></li>
                    <li className="nav-item"><a href="contact.html" className="nav-link">Contact</a></li>
                    <li className="nav-item cta"><a href="reservation.html" className="nav-link">Book a table</a></li>
                  </ul>
                </div>
              </div>
            </nav>
            <div className="header-background" style={{height: window.innerHeight}}>
              <img className="img-fluid" src={headerBackground}/>
            </div>
            <div className="py-1 top">
              <div className="container">
                <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
                  <div className="col-lg-12 d-block">
                    <div className="row d-flex">
                      <div className="col-md pr-4 d-flex topper align-items-center">
                        <div className="icon mr-2 d-flex justify-content-center align-items-center"><span className="icon-phone2"></span></div>
                        <a href="https://g.page/Dear-coffee-hostel?share" target="_blank"><span className="text">129 Lê Tấn Trung, Sơn Trà, Đà Nẵng</span></a>
                      </div>
                      <div className="col-md pr-4 d-flex topper align-items-center">
                        <div className="icon mr-2 d-flex justify-content-center align-items-center"><span className="icon-paper-plane"></span></div>
                        <span className="text">dearcoffeehostel@gmail.com</span>
                      </div>
                      <div className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right justify-content-end">
                        <p className="mb-0 register-link"><span>Open hours:</span> <span>Monday - Sunday</span> <span>7:00AM - 10:00PM</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="middle">
              <div className="container">
                <div className="row slider-text js-fullheight justify-content-center align-items-center">
                  <div className="col-md-12 col-sm-12 text-center">
                    <span className="heading">Dear,</span>
                    <h1 className="subheading mb-4">Coffee & Hostel</h1>
                  </div>

                </div>
              </div>
            </div>
            <section className="ftco-section ftco-no-pt ftco-no-pb">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="featured">
                      <div className="row">
                        <div className="col-6 col-md-3">
                          <div className="featured-menus ftco-animate" onClick={() => this.executeScroll(this.coffeeRef)}>
                            <img className="menu-img img" src={branchCoffee} />
                            <div className="text text-center">
                              <h3>Coffee</h3>
                              <p><span>Americano</span>, <span>Capuchino</span>, <span>...</span></p>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-3">
                          <div className="featured-menus ftco-animate" onClick={() => this.executeScroll(this.cakeRef)}>
                            <img className="menu-img img" src={branchCake} />
                            <div className="text text-center">
                              <h3>Cakes</h3>
                              <p><span>Flan</span>, <span>Cookies</span>, <span>green bean cake</span>, <span>...</span></p>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-3">
                          <div className="featured-menus ftco-animate" onClick={() => this.executeScroll(this.milkRef)}>
                            <img className="menu-img img" src={branchTea} />
                            <div className="text text-center">
                              <h3>Juice & Tea</h3>
                              <p><span>Oranges</span>, <span>Cung Đình Tea</span>, <span>Coconus</span>, <span>...</span></p>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-3">
                          <div className="featured-menus ftco-animate" onClick={() => this.executeScroll(this.hostelRef)}>
                            <img className="menu-img img" src="https://a0.muscache.com/im/pictures/e8fe3107-b399-49a7-87d6-c4e07f65cf0b.jpg?aki_policy=xx_large" />
                            <div className="text text-center">
                              <h3>Hostel</h3>
                              <p><span>Superior Double Room</span>, <span>Double Room (Bed x 2)</span>, ...</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div id='body'>
            <section ref={this.coffeeRef} className="ft-section-coffee">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="ft-section-item">
                      <img className="img-fluid" src={featureCoffee} />
                      <img className="img-fluid img-2" src={featureCoffee2} style={{marginLeft: '30px', marginTop: '50px'}} />
                      <div className="ft-section-item-content">
                        <h1>Coffee</h1>
                        <span>Today's plan, drink coffee and be awesome</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-lg-6">
                        <Menu>
                          {
                            coffeeMenu.slice(0,5).map((item) => {
                              return <MenuItem
                                imageSrc={item['image-src']}
                                title={item.name}
                                description={item.description}
                                price={item.price ? item.price.toLocaleString() : ''}
                              />
                            })
                          }
                        </Menu>
                      </div>
                      <div className="col-lg-6">
                        <Menu>
                          {
                            coffeeMenu.slice(5,10).map((item) => {
                              return <MenuItem
                                imageSrc={item['image-src']}
                                title={item.name}
                                description={item.description}
                                price={item.price ? item.price.toLocaleString() : ''}
                              />
                            })
                          }
                        </Menu>
                      </div>
                    </div>
                    <div className="divider"></div>
                  </div>
                </div>
              </div>
            </section>
            <section ref={this.cakeRef} className="ft-section-cake">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="ft-section-item">
                      <img className="img-fluid" src={featureCream} style={{marginRight: '30px', marginTop: '50px', width: '187px', height: '280px'}}/>
                      <img className="img-fluid img-2" src={featureCake2} style={{width: '187px', height: '280px', marginLeft: '30px', marginTop: '50px'}} />
                      <div className="ft-section-item-content">
                        <h1>Yogurt & Icecream </h1>
                        <span>Today's plan, drink coffee and be awesome</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-lg-6">
                        <Menu>
                          {
                            cakeMenu.slice(0,5).map((item) => {
                              return <MenuItem
                                imageSrc={item['image-src']}
                                title={item.name}
                                description={item.description}
                                price={item.price ? item.price.toLocaleString() : ''}
                              />
                            })
                          }
                        </Menu>
                      </div>
                      <div className="col-lg-6">
                        <Menu>
                          {
                            cakeMenu.slice(5,10).map((item) => {
                              return <MenuItem
                                imageSrc={item['image-src']}
                                title={item.name}
                                description={item.description}
                                price={item.price ? item.price.toLocaleString(): ''}
                              />
                            })
                          }
                        </Menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section ref={this.milkRef} className="ft-section-coffee">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="ft-section-item">
                      <img className="img-fluid" src={featureMilk} />
                      <div className="ft-section-item-content">
                        <h1>Milks</h1>
                        <span>Today's plan, drink coffee and be awesome</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-lg-6">
                        <Menu>
                          {
                            milkMenu.slice(0,5).map((item) => {
                              return <MenuItem
                                imageSrc={item['image-src']}
                                title={item.name}
                                description={item.description}
                                price={item.price ? item.price.toLocaleString() : ''}
                              />
                            })
                          }
                        </Menu>
                      </div>
                      <div className="col-lg-6">
                        <Menu>
                          {
                            milkMenu.slice(5,10).map((item) => {
                              return <MenuItem
                                imageSrc={item['image-src']}
                                title={item.name}
                                description={item.description}
                                price={item.price ? item.price.toLocaleString() : ''}
                              />
                            })
                          }
                        </Menu>
                      </div>
                    </div>
                    <div className="divider"></div>
                  </div>
                </div>
              </div>
            </section>
            <section ref={this.hostelRef} className="ft-section-hostel">
              <div className="ft-section-header">
                <div className="ft-section-banner">
                  <div className="ft-section-banner-img">
                    <img className="menu-img img" src={hostelBackground} />
                  </div>
                  <div className="ft-section-banner-title">
                    <div className="container">
                      <div className="row slider-text js-fullheight justify-content-center align-items-center">
                        <div className="col-md-12 col-sm-12 text-center">
                          <span className="heading">Dear,</span>
                          <h1 className="subheading mb-4">Hostel</h1>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="ft-section-body">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="card" style={{cursor: 'pointer'}} onClick={ () => { window.open("https://m.me/107072277488178", '_blank'); }}>
                        <img src="https://a0.muscache.com/im/pictures/31b2d5c0-9f04-4a65-840d-3700f82a8250.jpg?aki_policy=xx_large" className="card-img-top img-fluid" style={{maxHeight: '275px', objectFit: 'cover'}}/>
                        <div className="card-body">
                          <h5 className="card-title font-weight-bold">{sdr.name}</h5>
                          <p className="card-text">
                            <img src={bedIcon} style={{width: '24px', height: '24px'}}/>
                            <img src={chairIcon} style={{width: '24px', height: '24px', marginLeft: '5px'}}/>
                            <img src={bathIcon} style={{width: '28px', height: '28px', marginLeft: '5px'}}/>
                          </p>
                          <p className="card-text">
                            <del className="text-danger">{sdr.price ? sdr.price.toLocaleString() : ''} vnđ</del>
                            <div><span className="font-weight-bold">{(sdr.price - sdr.sale) ? (sdr.price - sdr.sale).toLocaleString() : ''} vnđ</span> / night</div>
                          </p>
                          <p className="card-text"><small className="text-success">Available</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div id="owl-carousel" class="owl-carousel owl-theme">
                        {
                          hostelRooms.superior.map((item) => {
                            return <div style={{height: '482px', display: 'flex', justifyContent: 'center'}}>
                              <img className="img-fluid" style={{width: 'unset', height: '100%'}}  src={item.image} />
                            </div>
                          })
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row pt-5">
                    <div className="col-lg-3">
                      <div className="card" style={{cursor: 'pointer'}} onClick={ () => { window.open("https://m.me/107072277488178", '_blank'); }}>
                        <img src="https://q-cf.bstatic.com/images/hotel/max1024x768/240/240231249.jpg" className="card-img-top img-fluid" style={{maxHeight: '275px', objectFit: 'cover'}}/>
                        <div className="card-body">
                          <h5 className="card-title font-weight-bold">{dorm.name}</h5>
                          <p className="card-text">
                            <img src={bedIcon} style={{width: '24px', height: '24px'}}/>
                            <img src={chairIcon} style={{width: '24px', height: '24px', marginLeft: '5px'}}/>
                            <img src={bathIcon} style={{width: '28px', height: '28px', marginLeft: '5px'}}/>
                          </p>
                          <p className="card-text">
                            <del className="text-danger">{dorm.price} vnđ</del>
                            <div><span className="font-weight-bold">{(dorm.price - dorm.sale) ? (dorm.price - dorm.sale).toLocaleString() : ''} vnđ</span> / night</div>
                          </p>
                          <p className="card-text"><small className="text-success">Available</small></p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div id="owl-carousel" class="owl-carousel owl-theme">
                        {
                          hostelRooms.dorm.map((item) => {
                            return <div style={{height: '482px', display: 'flex', justifyContent: 'center'}}>
                              <img className="img-fluid" style={{width: 'unset', height: '100%'}}  src={item.image} />
                            </div>
                          })
                        }
                      </div>
                    </div>
                  </div>
                  {
                    // <div className="row" style={{marginTop: '60px'}}>
                    //   <div className="col-lg-3">
                    //     <div className="card">
                    //       <img src="https://a0.muscache.com/im/pictures/e811eca0-3fea-4a89-a3be-89a8be7faae1.jpg?aki_policy=xx_large" className="card-img-top" style={{maxHeight: '275px', objectFit: 'cover'}}/>
                    //       <div className="card-body">
                    //         <h5 className="card-title font-weight-bold">Double Room With bacon (Bed x 2)</h5>
                    //         <p className="card-text">
                    //           <img src={bedIcon} style={{width: '24px', height: '24px'}}/>
                    //           <img src={chairIcon} style={{width: '24px', height: '24px', marginLeft: '5px'}}/>
                    //           <img src={bathIcon} style={{width: '28px', height: '28px', marginLeft: '5px'}}/>
                    //         </p>
                    //         <p className="card-text">
                    //           <del className="text-danger">650.000 vnđ</del>
                    //           <div><span className="font-weight-bold">600.000 vnđ</span> / night</div>
                    //         </p>
                    //         <p className="card-text"><small className="text-success">Available</small></p>
                    //       </div>
                    //     </div>
                    //   </div>
                    //   <div className="col-lg-9">
                    //     <div id="owl-carousel" class="owl-carousel owl-theme">
                    //       {
                    //         hostelRooms.double.map((item) => {
                    //           return <div style={{height: '482px', display: 'flex', justifyContent: 'center'}}>
                    //             <img className="img-fluid" style={{width: 'unset', height: '100%'}}  src={item.image} />
                    //           </div>
                    //         })
                    //       }
                    //     </div>
                    //   </div>
                    // </div>
                  }
                </div>
              </div>
            </section>
          </div>
          <div id='footer'>
            <footer class="ftco-footer ftco-bg-dark">
              <div class="container">
                <div class="row mb-5">
                  <div class="col-md-6 col-lg-3">
                    <div class="ftco-footer-widget mb-4">
                      <h2 class="ftco-heading-2">Dear, Coffee & Hostel</h2>
                      <p>Lovely coffee shop and Warn hostel</p>
                      <ul class="ftco-footer-social list-unstyled float-md-left float-lft mt-3">
                        <li class="ftco-animate"><a href="#"><span class="icon-twitter"></span></a></li>
                        <li class="ftco-animate"><a href="https://www.facebook.com/Dear-Coffee-Hostel-107072277488178/" target="_blank"><img src={fbIcon}/></a></li>
                        <li class="ftco-animate"><a href="#"><span class="icon-instagram"></span></a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <div class="ftco-footer-widget mb-4">
                      <h2 class="ftco-heading-2">Open Hours</h2>
                      <ul class="list-unstyled open-hours">
                        <li class="d-flex"><span>Monday</span><span>7:00 - 22:00</span></li>
                        <li class="d-flex"><span>Tuesday</span><span>7:00 - 22:00</span></li>
                        <li class="d-flex"><span>Wednesday</span><span>7:00 - 22:00</span></li>
                        <li class="d-flex"><span>Thursday</span><span>7:00 - 22:00</span></li>
                        <li class="d-flex"><span>Friday</span><span>7:00 - 22:00</span></li>
                        <li class="d-flex"><span>Saturday</span><span>7:00 - 22:00</span></li>
                        <li class="d-flex"><span>Sunday</span><span> 7:00 - 22:00</span></li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                     <div class="ftco-footer-widget mb-4">
                      <h2 class="ftco-heading-2">Albums</h2>
                      <div class="thumb d-flex">
        	            	{
                          hostelRooms.superior.slice(0,3).map((item) => {
                            return <a href="#" class="thumb-menu img" style={{backgroundImage: `url(${item.image})`}}></a>
                          })
                        }
        	            </div>
        	            <div class="thumb d-flex">
                        {
                          hostelRooms.superior.slice(3,6).map((item) => {
                            return <a href="#" class="thumb-menu img" style={{backgroundImage: `url(${item.image})`}}></a>
                          })
                        }
        	            </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <div class="ftco-footer-widget mb-4">
                    	<h2 class="ftco-heading-2">Newsletter</h2>
                    	<p>Far far away, behind the word mountains, far from the countries.</p>
                      <form action="#" class="subscribe-form">
                        <div class="form-group">
                          <input type="text" class="form-control mb-2 text-center" placeholder="Enter email address" />
                          <input type="submit" value="Subscribe" class="form-control submit px-3" />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">

                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
    );
  }

}

export default App;
